var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "default-page-paddings" }, [
    _c(
      "div",
      { staticClass: "container container-medium article" },
      [
        !_vm.inModal
          ? _c("Heading", {
              attrs: {
                title: _vm.$t("new_account_pc"),
                routeName: "confidentiality",
                alignment: "text-left",
              },
            })
          : _vm._e(),
        _c(
          "div",
          { staticClass: "default-content reading" },
          [
            _vm.locale == "ro"
              ? [
                  _c("p", [
                    _vm._v(
                      " Uniunea Națională a Transportatorilor Rutieri din România (UNTRR) prelucrează datele dumneavoastră cu caracter personal, prin mijloace automatizate, scopul fiind evidența persoanelor delegate și/sau împuternicite ale firmelor membre UNTRR, emiterea rovinietelor, facturarea și înregistrarea plății pentru produsele și serviciile furnizate de UNTRR conform comenzii dumneavoastră și informarea ulterioară a dumneavoastră de la distanță privind serviciul prestat, când e cazul."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Nu sunteți obligat(ă) să furnizați datele, acestea fiind necesare îndeplinirii comenzii dvs., refuzul dvs. determină imposibilitatea de a realiza serviciul solicitat."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Datele cu caracter personal vor fi procesate doar în urma acordului primit de la dumneavoastră."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      " Informațiile înregistrate sunt destinate utilizării de către operator și sunt comunicate numai următorilor terți:  Compania Națională de Autostrăzi și Drumuri Naționale din România, pentru emiterea  rovinietei, furnizorului de servicii de trimitere SMS (pentru trimiterea seriei rovinietei prin SMS, în cazul comenzilor înregistrate pe site-ul www.e-rovinieta.ro), procesatorului de plăți  online cu cardul bancar (în cazul plăților online cu cardul bancar). Datele personale necesare efectuării plăților online cu cardul vor fi transferate securizat către procesatorul de plăți."
                    ),
                  ]),
                  _vm._m(0),
                  _vm._m(1),
                  _c("p", [
                    _vm._v(
                      "(1) În cazul în care datele cu caracter personal referitoare la o persoană vizată sunt colectate de la aceasta, operatorul, în momentul obţinerii acestor date cu caracter personal, furnizează persoanei vizate toate informaţiile următoare:"
                    ),
                  ]),
                  _vm._m(2),
                  _c("p", [
                    _vm._v(
                      "(2) În plus faţă de informaţiile menţionate la alineatul (1), în momentul în care datele cu caracter personal sunt obţinute, operatorul furnizează persoanei vizate următoarele informaţii suplimentare necesare pentru a asigura o prelucrare echitabilă şi transparentă:"
                    ),
                  ]),
                  _vm._m(3),
                  _c("p", [
                    _vm._v(
                      "(3) În cazul în care operatorul intenţionează să prelucreze ulterior datele cu caracter personal într-un alt scop decât cel pentru care acestea au fost colectate, operatorul furnizează persoanei vizate, înainte de această prelucrare ulterioară, informaţii privind scopul secundar respectiv şi orice informaţii suplimentare relevante, în conformitate cu alineatul (2)."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(4) Alineatele (1), (2) şi (3) nu se aplică dacă şi în măsura în care persoana vizată deţine deja informaţiile respective."
                    ),
                  ]),
                  _vm._m(4),
                  _c("p", [_vm._v(" ")]),
                  _vm._m(5),
                  _c("p", [
                    _vm._v(
                      "(1) În cazul în care datele cu caracter personal nu au fost obţinute de la persoana vizată, operatorul furnizează persoanei vizate următoarele informaţii:"
                    ),
                  ]),
                  _vm._m(6),
                  _c("p", [
                    _vm._v(
                      "(2) Pe lângă informaţiile menţionate la alineatul (1), operatorul furnizează persoanei vizate următoarele informaţii necesare pentru a asigura o prelucrare echitabilă şi transparentă în ceea ce priveşte persoana vizată:"
                    ),
                  ]),
                  _vm._m(7),
                  _c("p", [
                    _vm._v(
                      "(3) Operatorul furnizează informaţiile menţionate la alineatele (1) şi (2):"
                    ),
                  ]),
                  _vm._m(8),
                  _c("p", [
                    _vm._v(
                      "(4) În cazul în care operatorul intenţionează să prelucreze ulterior datele cu caracter personal într-un alt scop decât cel pentru care acestea au fost obţinute, operatorul furnizează persoanei vizate, înainte de această prelucrare ulterioară, informaţii privind scopul secundar respectiv şi orice informaţii suplimentare relevante, în conformitate cu alineatul (2)."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(5) Alineatele (1)-(4) nu se aplică dacă şi în măsura în care:"
                    ),
                  ]),
                  _vm._m(9),
                  _vm._m(10),
                  _c("p", [
                    _vm._v(
                      "(1) Persoana vizată are dreptul de a obţine din partea operatorului o confirmare că se prelucrează sau nu date cu caracter personal care o privesc şi, în caz afirmativ, acces la datele respective şi la următoarele informaţii:"
                    ),
                  ]),
                  _vm._m(11),
                  _c("p", [
                    _vm._v(
                      "(2) În cazul în care datele cu caracter personal sunt transferate către o ţară terţă sau o organizaţie internaţională, persoana vizată are dreptul să fie informată cu privire la garanţiile adecvate în temeiul articolului 46 referitoare la transfer."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(3) Operatorul furnizează o copie a datelor cu caracter personal care fac obiectul prelucrării. Pentru orice alte copii solicitate de persoana vizată, operatorul poate percepe o taxă rezonabilă, bazată pe costurile administrative. În cazul în care persoana vizată introduce cererea în format electronic şi cu excepţia cazului în care persoana vizată solicită un alt format, informaţiile sunt furnizate într-un format electronic utilizat în mod curent."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(4) Dreptul de a obţine o copie menţionată la alineatul (3) nu aduce atingere drepturilor şi libertăţilor altora."
                    ),
                  ]),
                  _vm._m(12),
                  _vm._m(13),
                  _c("p", [
                    _vm._v(
                      "Persoana vizată are dreptul de a obţine de la operator, fără întârzieri nejustificate, rectificarea datelor cu caracter personal inexacte care o privesc. Ţinându-se seama de scopurile în care au fost prelucrate datele, persoana vizată are dreptul de a obţine completarea datelor cu caracter personal care sunt incomplete, inclusiv prin furnizarea unei declaraţii suplimentare."
                    ),
                  ]),
                  _vm._m(14),
                  _c("p", [
                    _vm._v(
                      "(1) Persoana vizată are dreptul de a obţine din partea operatorului ştergerea datelor cu caracter personal care o privesc, fără întârzieri nejustificate, iar operatorul are obligaţia de a şterge datele cu caracter personal fără întârzieri nejustificate în cazul în care se aplică unul dintre următoarele motive:"
                    ),
                  ]),
                  _vm._m(15),
                  _c("p", [
                    _vm._v(
                      "Contul va fi șters in maxim 30 de zile de la solicitarea primită din partea clientului."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(2) În cazul în care operatorul a făcut publice datele cu caracter personal şi este obligat, în temeiul alineatului (1), să le şteargă, operatorul, ţinând seama de tehnologia disponibilă şi de costul implementării, ia măsuri rezonabile, inclusiv măsuri tehnice, pentru a informa operatorii care prelucrează datele cu caracter personal că persoana vizată a solicitat ştergerea de către aceşti operatori a oricăror linkuri către datele respective sau a oricăror copii sau reproduceri ale acestor date cu caracter personal."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(3) Alineatele (1) şi (2a) nu se aplică în măsura în care prelucrarea este necesară:"
                    ),
                  ]),
                  _vm._m(16),
                  _vm._m(17),
                  _c("p", [
                    _vm._v(
                      "(1) Persoana vizată are dreptul de a obţine din partea operatorului restricţionarea prelucrării în cazul în care se aplică unul din următoarele cazuri:"
                    ),
                  ]),
                  _vm._m(18),
                  _c("p", [
                    _vm._v(
                      "(2) În cazul în care prelucrarea a fost restricţionată în temeiul alineatului (1), astfel de date cu caracter personal pot, cu excepţia stocării, să fie prelucrate numai cu consimţământul persoanei vizate sau pentru constatarea, exercitarea sau apărarea unui drept în instanţă sau pentru protecţia drepturilor unei alte persoane fizice sau juridice sau din motive de interes public important al Uniunii sau al unui stat membru."
                    ),
                  ]),
                  _c("p", [
                    _vm._v(
                      "(3) O persoană vizată care a obţinut restricţionarea prelucrării în temeiul alineatului (1) este informată de către operator înainte de ridicarea restricţiei de prelucrare."
                    ),
                  ]),
                  _c("p", [_vm._v(" ")]),
                  _vm._m(19),
                  _c("p", [_vm._v(" ")]),
                  _c("p", [_vm._v(" ")]),
                  _c("p", [_vm._v(" ")]),
                  _c("p", [_vm._v(" ")]),
                ]
              : [_vm._m(20)],
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Conform REGULAMENTULUI (UE) 2016/679 AL PARLAMENTULUI EUROPEAN ȘI AL CONSILIULUI din 27 aprilie 2016"
        ),
      ]),
      _vm._v(
        " privind protecția persoanelor fizice în ceea ce privește prelucrarea datelor cu caracter personal și privind libera circulație a acestor date și de abrogare a Directivei 95/46/CE (Regulamentul general privind protecția datelor):"
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(" "),
      _c("strong", [
        _vm._v(
          "Art. 13: Informaţii care se furnizează în cazul în care datele cu caracter personal sunt colectate de la persoana vizată "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) identitatea şi datele de contact ale operatorului şi, după caz, ale reprezentantului acestuia;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) datele de contact ale responsabilului cu protecţia datelor, după caz;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) scopurile în care sunt prelucrate datele cu caracter personal, precum şi temeiul juridic al prelucrării;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) în cazul în care prelucrarea se face în temeiul articolului 6 alineatul (1) litera (f), interesele legitime urmărite de operator sau de o parte terţă;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) destinatarii sau categoriile de destinatari ai datelor cu caracter personal;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) dacă este cazul, intenţia operatorului de a transfera date cu caracter personal către o ţară terţă sau o organizaţie internaţională şi existenţa sau absenţa unei decizii a Comisiei privind caracterul adecvat sau, în cazul transferurilor menţionate la articolul 46 sau 47 sau la articolul 49 alineatul (1) al doilea paragraf, o trimitere la garanţiile adecvate sau corespunzătoare şi la mijloacele de a obţine o copie a acestora, în cazul în care acestea au fost puse la dispoziţie."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) perioada pentru care vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) existenţa dreptului de a solicita operatorului, în ceea ce priveşte datele cu caracter personal referitoare la persoana vizată, accesul la acestea, rectificarea sau ştergerea acestora sau restricţionarea prelucrării sau a dreptului de a se opune prelucrării, precum şi a dreptului la portabilitatea datelor;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) atunci când prelucrarea se bazează pe articolul 6 alineatul (1) litera (a) sau pe articolul 9 alineatul (2) litera (a), existenţa dreptului de a retrage consimţământul în orice moment, fără a afecta legalitatea prelucrării efectuate pe baza consimţământului înainte de retragerea acestuia;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) dreptul de a depune o plângere în faţa unei autorităţi de supraveghere;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) dacă furnizarea de date cu caracter personal reprezintă o obligaţie legală sau contractuală sau o obligaţie necesară pentru încheierea unui contract, precum şi dacă persoana vizată este obligată să furnizeze aceste date cu caracter personal şi care sunt eventualele consecinţe ale nerespectării acestei obligaţii;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) existenţa unui proces decizional automatizat incluzând crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin în cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("table", { staticClass: "table table-bordered" }, [
      _c("tbody", [
        _c("tr", [
          _c("td", { attrs: { width: "150" } }, [
            _c("p", [_c("strong", [_vm._v("Date personale")])]),
          ]),
          _c("td", { attrs: { width: "420" } }, [
            _c("p", [_c("strong", [_vm._v("Motiv")])]),
          ]),
          _c("td", { attrs: { width: "*" } }, [
            _c("p", [
              _c("strong", [
                _vm._v("Perioada stocării conform prevederilor legale"),
              ]),
            ]),
          ]),
        ]),
        _c("tr", [
          _c("td", [_vm._v(" Nume și prenume ")]),
          _c("td", [_c("p", [_vm._v("Emitere factură")])]),
          _c("td", [_c("p", [_vm._v("10 ani")])]),
        ]),
        _c("tr", [
          _c("td", [_c("p", [_vm._v("Adresă")])]),
          _c("td", [
            _c("p", [
              _vm._v(
                "Emitere factură conform codului fiscal art. 319 aliniatul 20"
              ),
            ]),
          ]),
          _c("td", [_c("p", [_vm._v("10 ani")])]),
        ]),
        _c("tr", [
          _c("td", [_c("p", [_vm._v(" ")]), _c("p", [_vm._v("Telefon")])]),
          _c("td", [
            _c("p", [_vm._v("Notificare emitere rovinietă (opțional)")]),
            _c("p", [
              _vm._v(
                "Contact in cazul in care datele sunt greșite sau comanda a eșuat"
              ),
            ]),
          ]),
          _c("td", [_c("p", [_vm._v("3 ani")])]),
        ]),
        _c("tr", [
          _c("td", [_c("p", [_vm._v(" ")]), _c("p", [_vm._v("E-mail")])]),
          _c("td", [
            _c("p", [_vm._v("Confirmare creare cont")]),
            _c("p", [_vm._v("Trimitere factura rovinietă")]),
            _c("p", [
              _vm._v(
                "Trimitere e-mail cu valabilitatea rovinietei conform solicitării clientului"
              ),
            ]),
            _c("p", [_vm._v("Notificare ștergere cont")]),
          ]),
          _c("td", [_c("p", [_vm._v("3 ani")])]),
        ]),
        _c("tr", [
          _c("td", [_c("p", [_vm._v("Date masina")])]),
          _c("td", [_c("p", [_vm._v("Emitere de rovinietă")])]),
          _c("td", [_c("p", [_vm._v("10 ani")])]),
        ]),
        _c("tr", [
          _c("td", [_c("p", [_vm._v(" ")]), _c("p", [_vm._v("IP Address")])]),
          _c("td", [
            _c("p", [
              _vm._v(
                "Logurile aplicatiei Web (această informație ne este necesară în caz de atac DDoS) sau analiză anonimă de trafic"
              ),
            ]),
          ]),
          _c("td", [_c("p", [_vm._v("30 de zile")])]),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          "Art. 14: Informaţii care se furnizează în cazul în care datele cu caracter personal nu au fost obţinute de la persoana vizată "
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) identitatea şi datele de contact ale operatorului şi, după caz, ale reprezentantului acestuia;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) datele de contact ale responsabilului cu protecţia datelor, după caz;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) scopurile în care sunt prelucrate datele cu caracter personal, precum şi temeiul juridic al prelucrării;"
        ),
      ]),
      _c("li", [_vm._v("d) categoriile de date cu caracter personal vizate;")]),
      _c("li", [
        _vm._v(
          "e) destinatarii sau categoriile de destinatari ai datelor cu caracter personal, după caz;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) dacă este cazul, intenţia operatorului de a transfera date cu caracter personal către un destinatar dintr-o ţară terţă sau o organizaţie internaţională şi existenţa sau absenţa unei decizii a Comisiei privind caracterul adecvat sau, în cazul transferurilor menţionate la articolul 46 sau 47 sau la articolul 49 alineatul (1) al doilea paragraf, o trimitere la garanţiile adecvate sau corespunzătoare şi la mijloacele de a obţine o copie a acestora, în cazul în care acestea au fost puse la dispoziţie."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) perioada pentru care vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) în cazul în care prelucrarea se face în temeiul articolului 6 alineatul (1) litera (f), interesele legitime urmărite de operator sau de o parte terţă;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) existenţa dreptului de a solicita operatorului, în ceea ce priveşte datele cu caracter personal referitoare la persoana vizată, accesul la acestea, rectificarea sau ştergerea acestora sau restricţionarea prelucrării şi a dreptului de a se opune prelucrării, precum şi a dreptului la portabilitatea datelor;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) atunci când prelucrarea se bazează pe articolul 6 alineatul (1) litera (a) sau pe articolul 9 alineatul (2) litera (a), existenţa dreptului de a retrage consimţământul în orice moment, fără a afecta legalitatea prelucrării efectuate pe baza consimţământului înainte de retragerea acestuia;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) dreptul de a depune o plângere în faţa unei autorităţi de supraveghere;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) sursa din care provin datele cu caracter personal şi, dacă este cazul, dacă acestea provin din surse disponibile public;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "g) existenţa unui proces decizional automatizat incluzând crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin în cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) într-un termen rezonabil după obţinerea datelor cu caracter personal, dar nu mai mare de o lună, ţinându-se seama de circumstanţele specifice în care sunt prelucrate datele cu caracter personal;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) dacă datele cu caracter personal urmează să fie utilizate pentru comunicarea cu persoana vizată, cel târziu în momentul primei comunicări către persoana vizată respectivă; sau"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) dacă se intenţionează divulgarea datelor cu caracter personal către un alt destinatar, cel mai târziu la data la care acestea sunt divulgate pentru prima oară."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [_vm._v("a) persoana vizată deţine deja informaţiile;")]),
      _c("li", [
        _vm._v(
          "b) furnizarea acestor informaţii se dovedeşte a fi imposibilă sau ar implica eforturi disproporţionate, în special în cazul prelucrării în scopuri de arhivare în interes public, în scopuri de cercetare ştiinţifică sau istorică ori în scopuri statistice, sub rezerva condiţiilor şi a garanţiilor prevăzute la articolul 89 alineatul (1), sau în măsura în care obligaţia menţionată la alineatul (1) din prezentul articol este susceptibil să facă imposibilă sau să afecteze în mod grav realizarea obiectivelor prelucrării respective In astfel de cazuri, operatorul ia măsuri adecvate pentru a proteja drepturile, libertăţile şi interesele legitime ale persoanei vizate, inclusiv punerea informaţiilor la dispoziţia publicului;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) obţinerea sau divulgarea datelor este prevăzută în mod expres de dreptul Uniunii sau de dreptul intern sub incidenţa căruia intră operatorul şi care prevede măsuri adecvate pentru a proteja interesele legitime ale persoanei vizate; sau"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) în cazul în care datele cu caracter personal trebuie să rămână confidenţiale în temeiul unei obligaţii statutare de secret profesional reglementate de dreptul Uniunii sau de dreptul intern, inclusiv al unei obligaţii legale de a păstra secretul."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [_vm._v("Art. 15: Dreptul de acces al persoanei vizate ")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [_vm._v("a) scopurile prelucrării;")]),
      _c("li", [_vm._v("b) categoriile de date cu caracter personal vizate;")]),
      _c("li", [
        _vm._v(
          "c) destinatarii sau categoriile de destinatari cărora datele cu caracter personal le-au fost sau urmează să le fie divulgate, în special destinatari din ţări terţe sau organizaţii internaţionale;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) acolo unde este posibil, perioada pentru care se preconizează că vor fi stocate datele cu caracter personal sau, dacă acest lucru nu este posibil, criteriile utilizate pentru a stabili această perioadă;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) existenţa dreptului de a solicita operatorului rectificarea sau ştergerea datelor cu caracter personal ori restricţionarea prelucrării datelor cu caracter personal referitoare la persoana vizată sau a dreptului de a se opune prelucrării;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) dreptul de a depune o plângere în faţa unei autorităţi de supraveghere;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "g) în cazul în care datele cu caracter personal nu sunt colectate de la persoana vizată, orice informaţii disponibile privind sursa acestora;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "h) existenţa unui proces decizional automatizat incluzând crearea de profiluri, menţionat la articolul 22 alineatele (1) şi (4), precum şi, cel puţin în cazurile respective, informaţii pertinente privind logica utilizată şi privind importanţa şi consecinţele preconizate ale unei astfel de prelucrări pentru persoana vizată."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Rectificare şi ştergere ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [_c("strong", [_vm._v("Art. 16: Dreptul la rectificare ")])])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v(
          'Art. 17: Dreptul la ştergerea datelor ("dreptul de a fi uitat") '
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) datele cu caracter personal nu mai sunt necesare pentru îndeplinirea scopurilor pentru care au fost colectate sau prelucrate;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) persoana vizată îşi retrage consimţământul pe baza căruia are loc prelucrarea, în conformitate cu articolul 6 alineatul (1) litera (a) sau cu articolul 9 alineatul (2) litera (a), şi nu există niciun alt temei juridic pentru prelucrarea;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) persoana vizată se opune prelucrării în temeiul articolului 21 alineatul (1) şi nu există motive legitime care să prevaleze în ceea ce priveşte prelucrarea sau persoana vizată se opune prelucrării în temeiul articolului 21 alineatul (2);"
        ),
      ]),
      _c("li", [
        _vm._v("d) datele cu caracter personal au fost prelucrate ilegal;"),
      ]),
      _c("li", [
        _vm._v(
          "e) datele cu caracter personal trebuie şterse pentru respectarea unei obligaţii legale care revine operatorului în temeiul dreptului Uniunii sau al dreptului intern sub incidenţa căruia se află operatorul;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "f) datele cu caracter personal au fost colectate în legătură cu oferirea de servicii ale societăţii informaţionale menţionate la articolul 8 alineatul (1)."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) pentru exercitarea dreptului la liberă exprimare şi la informare;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) pentru respectarea unei obligaţii legale care prevede prelucrarea în temeiul dreptului Uniunii sau al dreptului intern care se aplică operatorului sau pentru îndeplinirea unei sarcini executate în interes public sau în cadrul exercitării unei autorităţi oficiale cu care este învestit operatorul;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) din motive de interes public în domeniul sănătăţii publice, în conformitate cu articolul 9 alineatul (2) literele (h) şi (i) şi cu articolul 9 alineatul (3);"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) în scopuri de arhivare în interes public, în scopuri de cercetare ştiinţifică sau istorică ori în scopuri statistice, în conformitate cu articolul 89 alineatul (1), în măsura în care dreptul menţionat la alineatul (1) este susceptibil să facă imposibilă sau să afecteze în mod grav realizarea obiectivelor prelucrării respective; sau"
        ),
      ]),
      _c("li", [
        _vm._v(
          "e) pentru constatarea, exercitarea sau apărarea unui drept în instanţă."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _c("strong", [
        _vm._v("Art. 18: Dreptul la restricţionarea prelucrării "),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("ol", [
      _c("li", [
        _vm._v(
          "a) persoana vizată contestă exactitatea datelor, pentru o perioadă care îi permite operatorului să verifice exactitatea datelor;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "b) prelucrarea este ilegală, iar persoana vizată se opune ştergerii datelor cu caracter personal, solicitând în schimb restricţionarea utilizării lor;"
        ),
      ]),
      _c("li", [
        _vm._v(
          "c) operatorul nu mai are nevoie de datele cu caracter personal în scopul prelucrării, dar persoana vizată i le solicită pentru constatarea, exercitarea sau apărarea unui drept în instanţă; sau"
        ),
      ]),
      _c("li", [
        _vm._v(
          "d) persoana vizată s-a opus prelucrării în conformitate cu articolul 21 alineatul (1), pentru intervalul de timp în care se verifică dacă drepturile legitime ale operatorului prevalează asupra celor ale persoanei vizate."
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", [
      _vm._v(
        "Pentru exercitarea acestor drepturi, vă puteţi adresa cu o cerere scrisă, datată şi semnată la registratura UNTRR din Bucuresti, str. Ienachita Vacarescu nr. 60, sector 4, cod postal 040157 sau prin telefon la numarul 0720999216 sau prin e-mail la "
      ),
      _c(
        "a",
        {
          staticClass: "custom-link",
          attrs: { href: "mailto:protectiadatelor@untrr.ro" },
        },
        [_vm._v("protectiadatelor@untrr.ro")]
      ),
      _vm._v(
        " . De asemenea, vă este recunoscut dreptul de a vă adresa justiţiei."
      ),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("p", [
        _c("span", [
          _vm._v(
            "Uniunea Națională a Transportatorilor Rutieri din România (UNTRR) processes your personal data by automated means, the purpose being the record of the delegated and/or authorized persons of UNTRR member companies, issuing vignette invoicing and registration of payment for products and services provided by UNTRR according your order and your subsequent remote information on the service provided, where applicable."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "You are not obliged to provide the data, as they are necessary for the fulfilment of your order, your refusal makes it impossible to perform the requested service."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "Personal data will only be processed following the agreement received from you."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "The registered information is intended for use by the operator and is communicated only to the following third parties: Romanian National Highways and National Roads Company, for issuing the toll, to the SMS sending service provider (for sending the toll series via SMS, in case of orders registered on the website). On www.e-rovinieta.ro, the online payment processor with the bank card (in the case of online payments with the bank card). The personal data required to make online card payments will be securely transferred to the payment processor."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [
            _vm._v(
              "Pursuant to REGULATION (EU) 2016/679 OF THE EUROPEAN PARLIAMENT AND OF THE COUNCIL of 27 April 2016"
            ),
          ]),
        ]),
        _c("span", [
          _vm._v(
            " on the protection of individuals with regard to the processing of personal data and on the free movement of such data and repealing Directive 95/46/EC (General Data Protection Regulation):"
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [
            _vm._v(
              "Art. 13: Information to be provided if personal data is collected from the data subject "
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(1) If personal data concerning a data subject is collected from that data subject, the controller shall, when obtaining such personal data, provide the data subject with all the following information:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) the identity and contact details of the operator and, as the case may be, of his representative;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) the contact details of the data protection officer, as the case may be;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) the purposes for which the personal data are processed, as well as the legal basis of the processing;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(d) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) the recipients or categories of recipients of personal data;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) where applicable, the intention of the controller to transfer personal data to a third country or international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46 or 47 or Article 49 (1), second subparagraph, a reference to the appropriate or appropriate guarantees and the means of obtaining a copy if they have been made available."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(2) In addition to the information referred to in paragraph 1, when the personal data are obtained, the controller shall provide the data subject with the following additional information necessary to ensure fair and transparent processing:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, rectification or deletion thereof or restriction of processing or the right to oppose processing, as well as the right to portability data;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(c) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "d) the right to lodge a complaint with a supervisory authority;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) whether the provision of personal data is a legal or contractual obligation or an obligation necessary to conclude a contract, as well as whether the data subject is obliged to provide such personal data and what are the possible consequences of non-compliance with this obligation;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(3) If the controller intends to further process personal data for a purpose other than that for which they were collected, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in accordance with paragraph (2)."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(4) Paragraphs (1), (2) and (3) shall not apply if and in so far as the data subject already holds that information."
          ),
        ]),
      ]),
      _c("table", { staticClass: "table my-4" }, [
        _c("tbody", [
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_c("strong", [_vm._v("Personal data")])]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [_c("strong", [_vm._v("Reason")])]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [
                _c("strong", [
                  _vm._v("Storage period according to legal provisions"),
                ]),
              ]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_vm._v("Surname and name")]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [_vm._v("Issuance of invoice")]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("10 years")]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_vm._v("Address")]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [
                _vm._v(
                  "Issuance of invoice according to the tax code art. 319 paragraph 20"
                ),
              ]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("10 years")]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_vm._v("Telephone")]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [_vm._v("Vignette issue notification (optional)")]),
              _c("p", [
                _vm._v("Contact if the data is wrong or the order failed"),
              ]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("3 years")]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [_c("p", [_vm._v("Email")])]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [_vm._v("Confirm account creation")]),
              _c("p", [_vm._v("Send the vignette invoice")]),
              _c("p", [_vm._v("Account deletion notification")]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("3 years")]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_vm._v("Vehicle data")]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [_vm._v("Vignette issuance")]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("10 years")]),
            ]),
          ]),
          _c("tr", [
            _c("td", { attrs: { width: "104" } }, [
              _c("p", [_vm._v("IP Address")]),
            ]),
            _c("td", { attrs: { width: "447" } }, [
              _c("p", [
                _vm._v(
                  "Web application logs (this information is required in case of a DDoS attack) or anonymous traffic analysis"
                ),
              ]),
            ]),
            _c("td", { attrs: { width: "73" } }, [
              _c("p", [_vm._v("30 days")]),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [
            _vm._v(
              "Art. 14: Information to be provided if personal data was not obtained from the data subject "
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(1) If personal data have not been obtained from the data subject, the controller shall provide the data subject with the following information.:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) the identity and contact details of the operator and, as the case may be, of his representative;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) the contact details of the data protection officer, as the case may be;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) the purposes for which the personal data are processed, as well as the legal basis of the processing;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v("d) the categories of personal data concerned;"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) the recipients or categories of recipients of personal data, as the case may be;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) where applicable, the intention of the controller to transfer personal data to a recipient in a third country or an international organization and the existence or absence of a Commission decision on the appropriateness or, in the case of transfers referred to in Article 46, or 47 or in the second subparagraph of Article 49 (1), a reference to the appropriate or appropriate guarantees and to the means of obtaining a copy thereof, if they have been made available."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(2) In addition to the information referred to in paragraph 1, the controller shall provide the data subject with the following information necessary to ensure fair and transparent processing in respect of the data subject:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) the period for which the personal data will be stored or, if this is not possible, the criteria used to establish this period;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(b) where the processing is carried out pursuant to Article 6 (1) (f), the legitimate interests pursued by the controller or a third party;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) the existence of the right to request from the controller, as regards personal data concerning the data subject, access to them, their rectification or deletion or restriction of processing and the right to oppose processing, as well as the right to portability data;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(d) where the processing is based on Article 6 (1) (a) or Article 9 (2) (a), the existence of the right to withdraw consent at any time, without prejudice to the lawfulness of the processing carried out on the basis of consent before its withdrawal;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) the right to lodge a complaint with a supervisory authority;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) the source from which the personal data come and, if applicable, if they come from publicly available sources;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "g) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(3) The operator shall provide the information referred to in paragraphs (1) and (2):"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) within a reasonable time after obtaining the personal data, but not more than one month, taking into account the specific circumstances in which the personal data are processed;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) if the personal data are to be used for communication with the data subject, at the latest at the time of the first communication to the data subject concerned; or"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) if it is intended to disclose personal data to another recipient, at the latest on the date on which they are first disclosed."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(4) If the controller intends to further process personal data for a purpose other than that for which they were obtained, the controller shall provide the data subject, before such further processing, with information on that secondary purpose and any relevant additional information, in in accordance with paragraph (2)."
          ),
        ]),
      ]),
      _c("p", [
        _vm._v(
          "(5) Paragraphs (1)-(4) do not apply if and to the extent that:"
        ),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v("a) the data subject already has the information;"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) the provision of this information proves to be impossible or would involve disproportionate efforts, especially in the case of processing for archiving purposes in the public interest, for scientific or historical research purposes or for statistical purposes, subject to the conditions and guarantees provided in Article 89 (1), or in so far as the obligation referred to in paragraph 1 of this Article is likely to make it impossible or would seriously affect the achievement of the objectives of such processing, the operator shall take appropriate measures to protect the rights, freedoms and legitimate interests of the data subject, including making the information available to the public;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(c) the obtaining or disclosure of data is expressly provided for by Union or national law to which the controller is subject and which provides for appropriate measures to protect the legitimate interests of the data subject; or"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "d) where personal data must remain confidential under a statutory obligation of professional secrecy governed by Union or national law, including a legal obligation to maintain secrecy."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [
            _vm._v("Art. 15: The right of access of the data subject "),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(1) The data subject has the right to obtain from the controller a confirmation that personal data concerning him or her are being processed or not and, if so, access to those data and to the following information:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [_c("p", [_c("span", [_vm._v("a) processing purposes;")])])]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v("b) the categories of personal data concerned;"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) the recipients or categories of recipients to whom personal data have been or are to be disclosed, in particular recipients from third countries or international organizations;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "d) where possible, the period for which personal data are expected to be stored or, if this is not possible, the criteria used to establish this period;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) the existence of the right to request the operator to rectify or delete personal data or to restrict the processing of personal data relating to the data subject or the right to oppose the processing;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) the right to lodge a complaint with a supervisory authority;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "g) if personal data are not collected from the data subject, any available information on their source;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "h) the existence of an automated decision-making process including profiling, referred to in Article 22 (1) and (4), as well as, at least in those cases, relevant information on the logic used and on the importance and expected consequences of such processing for the data subject."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(2) Where personal data are transferred to a third country or an international organization, the data subject shall have the right to be informed of the appropriate safeguards under Article 46 concerning the transfer."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(3) The operator shall provide a copy of the personal data subject to processing. For any other copies requested by the data subject, the operator may charge a reasonable fee, based on administrative costs. Where the data subject submits the application in electronic format and unless the data subject requests another format, the information shall be provided in a commonly used electronic format."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(4) The right to obtain a copy referred to in paragraph 3 shall be without prejudice to the rights and freedoms of others."
          ),
        ]),
      ]),
      _c("p", [_c("span", [_c("strong", [_vm._v("Amendment and deletion")])])]),
      _c("p", [
        _c("span", [_c("strong", [_vm._v("Art. 16: The right to amend ")])]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "The data subject has the right to obtain from the controller, without undue delay, the rectification of inaccurate personal data concerning him. Taking into account the purposes for which the data were processed, the data subject has the right to obtain the completion of personal data that are incomplete, including by providing an additional statement."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [
            _vm._v(
              'Art. 17: The right to delete data ("the right to be forgotten") '
            ),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(1) The data subject has the right to obtain from the controller the deletion of personal data concerning him, without undue delay, and the controller has the obligation to delete personal data without undue delay if one of the following reasons applies:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) personal data are no longer necessary for the purposes for which they were collected or processed;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(b) the data subject withdraws his or her consent on the basis of which the processing takes place in accordance with Article 6 (1) (a) or Article 9 (2) (a), and there is no other legal basis for processing;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(c) the data subject opposes the processing pursuant to Article 21 (1) and there are no legitimate reasons prevailing in respect of the processing or the data subject opposes the processing pursuant to Article 21 (2);"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v("d) personal data have been illegally processed;"),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) personal data must be deleted in order to comply with a legal obligation incumbent on the controller under Union or national law to which the controller is subject;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "f) personal data have been collected in connection with the provision of information society services referred to in Article 8 paragraph (1)."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "The account will be deleted in maximum 30 days from the request received from the client."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "2. If the controller has made his personal data public and is obliged to delete them pursuant to paragraph (1), the controller shall, taking into account the available technology and the cost of implementation, take reasonable measures, including technical measures, to inform operators who process personal data that the data subject has requested the deletion by these operators of any links to those data or of any copies or reproductions of such personal data."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "3. Paragraphs 1 and 2a shall not apply in so far as processing is necessary:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) for the exercise of the right to free expression and information;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(b) for compliance with a legal obligation which provides for processing under Union or national law applicable to the controller or for the performance of a task performed in the public interest or in the exercise of official authority with which the controller is vested;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(c) for reasons of public interest in the field of public health, in accordance with Article 9 (2) (h) and (i) and Article 9 (1) (3);"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "d) for archiving purposes in the public interest, for scientific or historical research or for statistical purposes, in accordance with Article 89 (1), in so far as the right referred to in paragraph 1 is likely to make it impossible or seriously achieving the objectives of that processing; or"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "e) for ascertaining, exercising or defending a right in court."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _c("strong", [_vm._v("Art. 18: The right to restrict processing ")]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(1) The data subject has the right to obtain from the operator the restriction of processing if one of the following cases applies:"
          ),
        ]),
      ]),
      _c("ol", [
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "a) the data subject disputes the accuracy of the data, for a period which allows the controller to verify the accuracy of the data;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "b) the processing is illegal, and the data subject opposes the deletion of personal data, requesting in return the restriction of their use;"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "c) the controller no longer needs personal data for the purpose of processing, but the data subject requests them for the establishment, exercise or defence of a right in court; or"
              ),
            ]),
          ]),
        ]),
        _c("li", [
          _c("p", [
            _c("span", [
              _vm._v(
                "(d) the data subject has objected to the processing in accordance with Article 21 (1), for the period during which it is verified whether the legitimate rights of the controller prevail over those of the data subject."
              ),
            ]),
          ]),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "(2) Where processing has been restricted pursuant to paragraph 1, such personal data may, except in the case of storage, be processed only with the consent of the data subject or for the establishment, exercise or defence of a right in court or for the protection of rights. Another individual or legal entity or for reasons of important public interest of the Union or of a Member State."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "3. A data subject who has obtained a processing restriction pursuant to paragraph 1 shall be informed by the controller before the processing restriction is lifted."
          ),
        ]),
      ]),
      _c("p", [
        _c("span", [
          _vm._v(
            "To exercise these rights, you can address a written request, dated and signed at the UNTRR registry in Bucharest, str. Ienachita Vacarescu no. 60, 4"
          ),
        ]),
        _c("sup", [_c("span", [_vm._v("th")])]),
        _c("span", [
          _vm._v(
            " district, zip code 040157 or by phone at 0720999216 or by email at protectiadatelor@untrr.ro. You also have the right to go to court."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }